var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAside(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3043 0C16.3043 0 6.05591 2.56721 6.46817 10.2334C7.13601 14.7273 9.48752 18.0354 12.1643 21.1869C12.8901 22.0426 15.2359 24.5213 15.5495 25.8551C15.8862 27.2833 16.3217 29.1069 15.1953 31.1902C15.1953 31.1902 21.8378 26.4807 18.1856 20.5259C14.5333 14.5711 3.26881 6.52131 16.3043 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73112 9.23047C5.73112 9.23047 -0.992754 13.3144 1.59112 20.8921C4.17499 28.4698 8.43692 31.1846 8.43692 31.1846C8.43692 31.1846 11.044 33.5393 13.3143 31.9341C14.7311 30.9308 14.586 29.7977 14.3247 28.8947C14.0924 28.1039 13.6453 27.6849 11.346 25.519C9.47628 23.7544 1.06854 16.7374 5.73112 9.23047Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.922 35.5813C19.922 35.5813 30.1704 33.0141 29.7582 25.3478C29.539 21.2725 26.7388 17.5459 24.062 14.3944C23.3362 13.5387 20.9904 11.06 20.6769 9.72619C20.3401 8.298 19.9046 6.47439 21.0311 4.39111C21.0311 4.39111 14.3885 9.10062 18.0407 15.0554C21.693 21.0101 32.9575 29.0541 19.922 35.5813Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5015 26.3449C30.5015 26.3449 37.2254 22.261 34.6415 14.6832C32.0577 7.10554 27.7957 4.39079 27.7957 4.39079C27.7957 4.39079 25.1886 2.03604 22.9183 3.64128C21.5015 4.64456 21.6467 5.77768 21.908 6.68063C22.1402 7.47145 22.5873 7.89046 24.8867 10.0564C26.7506 11.821 35.1583 18.838 30.5015 26.3449Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAside);
export default __webpack_public_path__ + "static/media/logo_aside.8473e8b12062a795e9ae683765ad1182.svg";
export { ForwardRef as ReactComponent };